import React from "react";
import Header from "../components/Header";
import SignUpSection from "../sections/authentication/SignUpSection";

function SignUpPage() {
  return (
    <div className={ClassName.container}>
      <Header />
      <SignUpSection />
    </div>
  );
}

export default SignUpPage;

const ClassName = {
  container: "flex flex-col text-black relative font-main",
};
